export enum FeatureFlagKey {
  PRODUCT_CLASSIFICATION = 'PRODUCT_CLASSIFICATION',
}

export function isFeatureEnabled(flag: FeatureFlagKey): boolean {
  if(flag === FeatureFlagKey.PRODUCT_CLASSIFICATION) {
    return import.meta.env.REACT_APP_FF_PRODUCT_CLASSIFICATION === 'true';
  } 

  return false;
}
